<template>
  <div class="charpter1">
    
<CharpterOne/>

  </div>
</template>

<script>
// @ is an alias to /src
import CharpterOne from "@/components/CharpterOne.vue";

export default {
  name: "Charpter1",
  components: {
    CharpterOne
  }
};
</script>